import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';


interface CountdownDialog{
  time: number,
  messageTitle: string,
  message: string
}

@Component({
  selector: 'app-countdown-timer',
  templateUrl: './countdown-timer.component.html',
  styleUrls: ['./countdown-timer.component.css']
})

export class CountdownTimerComponent implements OnInit {

  countdown: number;
  
  constructor(@Inject(MAT_DIALOG_DATA) public data : CountdownDialog) { }
  ngOnInit(): void {
    this.countdown=this.data.time;
    setInterval(()=>{
      this.countdown--;
    }, 1000);
  }

}
